import { render, staticRenderFns } from "./LoadingNotification.vue?vue&type=template&id=811ed682"
import script from "./LoadingNotification.vue?vue&type=script&lang=js"
export * from "./LoadingNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports